import { Component, Input, OnInit } from "@angular/core";
import { Utilities } from "@tylertech/shared-module";
import { ICardMetadata, ClassMetadata } from "@tylertech/tyler-api-types";
import { ODataFilterFactoryService } from "@tylertech/odata-module";
import { MetadataService, CachedCodeLookupService } from "../../../services";
import { MetadataIntermediary } from "../../../interfaces";

@Component({
    selector: "card-list-item-body",
    templateUrl: "./cardListItemBody.tmpl.html",
    standalone: false
})
export class CardListItemBodyComponent implements OnInit
{
    @Input()
    cardMetadata: ICardMetadata;

    @Input()
    model: any;

    @Input()
    dense: boolean;

    displayModel: any;

    metadata: ClassMetadata;

    loading: boolean = true;

    constructor(
        private $cachedCodeLookupService: CachedCodeLookupService,
        private readonly $odataFilterFactory: ODataFilterFactoryService,
        private $metadataService: MetadataService
    ) { }

    ngOnInit(): void
    {
        this.loadCardView();
    }

    loadCardView(): void
    {
        const self = this;
        this.displayModel = Utilities.deepCopy(this.model);
        this.metadata = Utilities.deepCopy(this.cardMetadata.ViewMetaData);
        const properties = this.$metadataService.FlattenProperties(this.metadata, this.model.$$Parent, this.model);
        const propsWithWidth = properties.filter(x => x.property.DrawWidth !== 100);
        const autoSizeProperties = properties.length > 1 && propsWithWidth.length === 0;
        const loaders: Promise<string | void>[] = [];
        properties.forEach(p =>
        {
            loaders.push(
                this.getValue(p)
                    .then(v =>
                    {
                        self.displayModel[p.name] = v;
                        if (p.property.InputType === "Check")
                            p.property["$InputType"] = "Check";
                        if (p.property.InputType !== "Link" && p.property.InputType !== "Badge")
                            p.property.InputType = "LabelValue";
                        if (autoSizeProperties)
                            p.property.DrawWidth = 25;
                    })
            );
        });
        Promise.all(loaders).then(() => self.loading = false);
    }

    getValue(intermediary: MetadataIntermediary): Promise<string>
    {
        const value = intermediary.model[intermediary.name];
        if (Utilities.IsNullOrUndefined(value)) return Promise.resolve("");
        if (intermediary.property.Lookup)
        {
            let fieldValue = "";
            const builder = this.$odataFilterFactory.createBuilder();
            builder.filterEQ("Key", value);
            return this.$cachedCodeLookupService.Get(intermediary.property.Lookup, builder.build())
                .then(
                    x =>
                    {
                        if (x && x.length > 0)
                            fieldValue = x[0].Value;
                        intermediary.property.Lookup = undefined;
                        intermediary.property.InputType = "LabelValue";
                        return fieldValue;
                    },
                    () => "Error Loading"
                );
        }
        return Promise.resolve(this.$metadataService.getFormattedValue(intermediary));
    }
}
